<template>
    <div class="testimonialSlider__container">
        <div class="testimonialSlider__quoteContainer">
            <button
                class="testimonialSlider__prev"
                aria-label="Navigate to previous slide"
                @click="prevSlide"
            >
                <i class="fal fa-angle-left" />
            </button>
            <Swiper
                ref="quoteSlider"
                :options="quoteSliderOptions"
                @slideChange="changeSlide"
            >
                <SwiperSlide
                    v-for="(value, key) in slides"
                    :key="key"
                >
                    <div class="testimonialSlider__slide">
                        <slot :name="`quote-${key}`" />
                    </div>
                </SwiperSlide>
            </Swiper>
            <button
                class="testimonialSlider__next"
                aria-label="Navigate to next slide"
                @click="nextSlide"
            >
                <i class="fal fa-angle-right" />
            </button>
        </div>
        <Swiper
            ref="logoSlider"
            :options="logoSliderOptions"
            @slideChange="changeQuoteSlide"
            @click-slide="handleClickSlide"
        >
            <SwiperSlide
                v-for="(value, key) in slides"
                :key="key"
            >
                <div class="testimonialSlider__logoSlide">
                    <slot :name="`logo-${key}`" />
                </div>
            </SwiperSlide>
        </Swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {

    components: {
        Swiper,
        SwiperSlide,
    },

    props: {
        slides: {
            type: Array,
            required: true,
        },
    },

    data () {
        return {
            quoteSliderOptions: {
                loop: true,
                navigation: {
                    nextEl: '.js-quoteSlideNext',
                    prevEl: '.js-quoteSlidePrev',
                },
            },
            logoSliderOptions: {
                loop: true,
                slidesPerView: 1,
                loopFillGroupWithBlank: false,
                centeredSlides: true,
                breakpoints: {
                    575: {
                        slidesPerView: 3,
                    },
                    1024: {
                        slidesPerView: 5,
                    },
                },
            },
            autoPlayInterval: null,
        }
    },

    mounted () {
        this.startInterval()
    },

    methods: {
        handleClickSlide (index) {
            this.$refs.logoSlider.$swiper.slideTo(index)
        },

        nextLogoSlide () {
            const logoSlider = this.$refs.logoSlider.$swiper
            logoSlider.slideNext()
        },

        prevLogoSlide () {
            const logoSlider = this.$refs.logoSlider.$swiper
            logoSlider.slidePrev()
        },

        nextSlide () {
            const quoteSlider = this.$refs.quoteSlider.$swiper
            quoteSlider.slideNext()
        },

        prevSlide () {
            const quoteSlider = this.$refs.quoteSlider.$swiper
            quoteSlider.slidePrev()
        },

        changeSlide (swiper) {
            const { realIndex } = swiper

            this.$refs.logoSlider.$swiper.slideToLoop(realIndex)
        },

        changeQuoteSlide (swiper) {
            const { realIndex } = swiper

            this.$refs.quoteSlider.$swiper.slideToLoop(realIndex)
        },

        startInterval () {
            this.autoPlayInterval = setInterval(() => {
                const quoteSlider = this.$refs.quoteSlider.$swiper
                quoteSlider.slideNext()
            }, 6000)
        },
    },

}
</script>
